import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Button from "@mui/material/Button";
import CustomizedTables from "../../elements/table/table_record";
// import "./record.scss";

export default function AccordionUsage({ data }) {
  return (
    // <div className="accordion">
    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1-content"
        id="panel1-header"
      >
        <Typography component="span">{data.title}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <CustomizedTables data={data.record} />
      </AccordionDetails>
    </Accordion>
    // </div>
  );
}
